import React from 'react';
import {

    Link
} from "react-router-dom";

class NavOption {
    name;
    href;

    constructor(name, href) {
        this.name = name;
        this.href = href;
    }
}


function NavigationBar({options}) {
    return (
        <nav className={"h-12 flex flex-row items-center justify-between w-1/4 md:w-2/5 lg:w-3/12"}>
            {options.map((item) => (
                <Link key={item.name} href={item.href} to={item.href}
                      className={"hover:text-secondary hover:font-extrabold text-primary font-bold text-sm"}>
                    {item.name}
                </Link>
            ))}
        </nav>
    );
}

const withData = (Component) => {
    const navigation = [
        new NavOption('How to use', '#'),
        new NavOption('Tools & API', '#'),
        new NavOption('Pricing', '#'),
    ]

    return () => <Component options={navigation}/>
}

export default withData(NavigationBar);